import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

export default defineNuxtRouteMiddleware((to) => {
  if (!to.path.startsWith(ROOT_CATALOG_URL) || to.query.page !== '1') return;

  return navigateTo(
    { path: to.path, query: { ...to.query, page: undefined } },
    { redirectCode: 301, replace: true },
  );
});
